import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubSetupRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-setup',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/setup',
};
